import {connect} from '@modifi/redux'

import CompanyFinancialsFormContent, {
  CompanyFinancialsFormContentProps,
} from './CompanyFinancialsFormContent'
import {
  aEnsureFetchRevenueCategories,
  selectRevenueCategoryConfig,
} from '../../../../../data/revenue-categories'

const mapStateToProps = (
  state: Record<string, any>
): Pick<CompanyFinancialsFormContentProps, 'revenueCategoryOptions'> => ({
  revenueCategoryOptions: selectRevenueCategoryConfig(state),
})

const mapDispatchToProps = {
  fetchRevenueCategories: aEnsureFetchRevenueCategories,
}

export default connect(mapStateToProps, mapDispatchToProps)(CompanyFinancialsFormContent)
